import React, { useEffect, useState } from 'react';

import {
  CreateBase,
  SimpleForm,
  TextInput,
  SelectInput,
  useNotify,
  useRedirect,
  useCreate,
  required,
  useDataProvider,
  DateTimeInput,
  DateInput,
} from "react-admin";
import Box from "@mui/material/Box";
import ItemSelectInput from '../../components/ItemSelectInput.tsx'; // 根据实际路径调整

const typeChoices = [
  { id: 'FinishedGood', name: 'FinishedGood' },
  { id: 'RawMaterial', name: 'RawMaterial' },
];

const CustomerCreate: React.FC = () => {

  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();


  const handleSave = async (data: any) => {
    try {
      const productId = data.productId?.productId ?? data.productId;
      const payload = { ...data, productId };

      await create('Customer', { data: payload });
      notify('Save Success', { type: 'info' });
      redirect('list', 'Customer');
    } catch (error) {
      notify('Save Fail', { type: 'error' });
    }
  };

  return (
    <CreateBase resource="Customer" >
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }} onSubmit={handleSave}>
        <Box display="flex" flexDirection="row" gap={2} width="100%" >
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="customerName" label="customerName" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="email" label="email" fullWidth />
          </Box>

        </Box>

        <Box display="flex" gap={2} width="100%" >
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="phone" label="phone" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="building" label="building" fullWidth />
            <TextInput sx={{ mt: 1 }} source="road" label="road" fullWidth />

            <TextInput sx={{ mt: 1 }} source="city" label="city" fullWidth />

            <TextInput sx={{ mt: 1 }} source="country" label="country" fullWidth />

          </Box>
        </Box>

        <Box display="flex" gap={2} width="100%" >
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="attn" label="attn" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="fax" label="fax" fullWidth />
          </Box>
        </Box>
      </SimpleForm>
    </CreateBase>
  );
};

export default CustomerCreate;
